import { render, staticRenderFns } from "./list_elements.vue?vue&type=template&id=e811c820&lang=pug"
import script from "./list_elements.vue?vue&type=script&lang=js"
export * from "./list_elements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e811c820')) {
      api.createRecord('e811c820', component.options)
    } else {
      api.reload('e811c820', component.options)
    }
    module.hot.accept("./list_elements.vue?vue&type=template&id=e811c820&lang=pug", function () {
      api.rerender('e811c820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/help_center/components/list_elements.vue"
export default component.exports